import React from 'react';

export const StoresContext = React.createContext({});
